import { render, staticRenderFns } from "./EdificeSection.vue?vue&type=template&id=6e91a2bd&scoped=true"
import script from "./EdificeSection.vue?vue&type=script&lang=js"
export * from "./EdificeSection.vue?vue&type=script&lang=js"
import style0 from "./EdificeSection.vue?vue&type=style&index=0&id=6e91a2bd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e91a2bd",
  null
  
)

export default component.exports